import { CheckoutEventDTO, CheckoutEventTypes } from '../../../types/analytics/analytics-data'
import { siteNameStore, splitProductDescription } from '@utils/analytics/common'
import { CheckoutState } from '@hooks/use-checkout'
import { DetectSiteDomain } from '@utils/detect-site-domain'

/**
 * This transforms the checkout state for both furniture and non-Synsisal flooring sites
 * @param data
 * @param siteDomainInfo
 * @param promoCode
 * @param transactionId
 */
export const checkoutStateToDTO = (
  data: CheckoutState,
  siteDomainInfo: DetectSiteDomain,
  promoCode?: string,
  transactionId?: string,
): CheckoutEventDTO => {
  const { furnitureSite } = siteDomainInfo
  return {
    event: CheckoutEventTypes.PURCHASE,
    ecommerce: {
      affiliation: siteNameStore,
      coupon: promoCode || '',
      currency: 'USD',
      payment_type: 'credit card',
      shipping: parseFloat(data.totals.freight.replace('$', '').replace(',', '')),
      tax: parseFloat(data.totals.tax.replace('$', '').replace(',', '')),
      transaction_id: transactionId,
      value: parseFloat(data.totals.total.replace('$', '').replace(',', '')),
      items: data.items.map((item) => {
        const itemName = furnitureSite
          ? item.description
          : item.description?.split(':')?.length > 1
          ? item.description?.split(':')[0]
          : item.description
        return {
          affiliation: siteNameStore,
          coupon: promoCode || '',
          currency: 'USD',
          ...(item.metadata?.index && { index: item.metadata?.index }),
          ...(!furnitureSite && { item_brand: item.metadata?.brand }),
          item_category2: item.metadata?.category2 || '',
          item_category3: item.metadata?.category3 || '',
          item_category4: item.metadata?.category4 || '',
          item_category5: item.metadata?.category5 || '',
          item_category: item.metadata?.category || '',
          item_id: item.metadata?.contentful_id,
          item_list_name: item.metadata?.itemListName,
          item_name: itemName,
          ...(!furnitureSite && {
            item_stock_detail: 'In_stock', // stock of the product
          }),
          item_variant: (furnitureSite ? item.details : item.metadata?.category5) || '',
          price: parseFloat(item.netPrice.replace('$', '').replace(',', '')),
          quantity: item.quantity,
        }
      }),
    },
  }
}

export const checkoutStateSynsisalToDTO = (
  data: CheckoutState,
  transactionId?: string,
  previousRoute?: string,
): CheckoutEventDTO => {
  const items = data.items.map((item, index) => {
    const [name, color] = splitProductDescription(item.description)
    return {
      item_name: item.description,
      item_id: item.metadata?.contentful_id,
      affiliation: siteNameStore,
      currency: 'USD',
      price: 0,
      item_brand: 'synsisal',
      item_category: `Custom Rugs samples`,
      item_variant: color,
      item_stock_detail: 'In_stock',
      item_list_name: previousRoute ?? `Order ${name} ${item.metadata?.subType ?? 'weave'} samples`,
      index: index,
      quantity: item.quantity,
    }
  })
  return {
    event: CheckoutEventTypes.PURCHASE,
    ecommerce: {
      affiliation: siteNameStore,
      currency: 'USD',
      items: items,
      shipping: 0,
      tax: 0,
      transaction_id: transactionId,
      value: 'Free',
    },
  }
}
